import { useEffect, useRef, type RefObject } from "react";

const IDLE_MS = 160;
const SCROLL_ACTIVE_CLASS = "lane-scroll-active";
const HIGHWAY_ACTIVE_CLASS = "highway-scroll-active";

/**
 * Marca pentagrama y mástil como “en scroll” vía classList (sin setState).
 * Evita repintar React y activa CSS de bajo coste en el SVG del mástil.
 */
export function useLaneScrollInteraction(
  staffRef: RefObject<HTMLDivElement | null>,
  highwayRef: RefObject<HTMLDivElement | null>,
  _programmaticScrollRef: RefObject<boolean>,
  _programmaticScrollUntilRef: RefObject<number>,
  attachKey: unknown = true
): void {
  const idleTimerRef = useRef(0);

  useEffect(() => {
    const staff = staffRef.current;
    const highway = highwayRef.current;
    if (!staff || !highway) return;

    const bump = () => {
      staff.classList.add(SCROLL_ACTIVE_CLASS);
      highway.classList.add(SCROLL_ACTIVE_CLASS, HIGHWAY_ACTIVE_CLASS);
      window.clearTimeout(idleTimerRef.current);
      idleTimerRef.current = window.setTimeout(() => {
        staff.classList.remove(SCROLL_ACTIVE_CLASS);
        highway.classList.remove(SCROLL_ACTIVE_CLASS, HIGHWAY_ACTIVE_CLASS);
      }, IDLE_MS);
    };

    const opts: AddEventListenerOptions = { passive: true };
    staff.addEventListener("scroll", bump, opts);
    highway.addEventListener("scroll", bump, opts);
    staff.addEventListener("wheel", bump, opts);
    highway.addEventListener("wheel", bump, opts);
    staff.addEventListener("touchstart", bump, opts);
    highway.addEventListener("touchstart", bump, opts);

    return () => {
      window.clearTimeout(idleTimerRef.current);
      staff.classList.remove(SCROLL_ACTIVE_CLASS);
      highway.classList.remove(SCROLL_ACTIVE_CLASS, HIGHWAY_ACTIVE_CLASS);
      staff.removeEventListener("scroll", bump);
      highway.removeEventListener("scroll", bump);
      staff.removeEventListener("wheel", bump);
      highway.removeEventListener("wheel", bump);
      staff.removeEventListener("touchstart", bump);
      highway.removeEventListener("touchstart", bump);
    };
  }, [staffRef, highwayRef, attachKey]);
}
